import BemIt, { addClass } from "@gtechdoodler/bem-it";
import useViewport from "../../../hooks/useViewport/useViewport";
import { StyledSection } from "./Section.styles";
import { SectionProps } from "./Section.types";

const Section = ({
	children,
	backgroundColor = "bg_white",
	roundedCorners = false,
	className,
	...props
}: SectionProps) => {
	const block = new BemIt("Section");
	const viewport = useViewport();

	return (
		<StyledSection
			className={addClass(className).after(block)}
			backgroundColor={backgroundColor}
			viewport={viewport}
			roundedCorners={roundedCorners}
			{...props}
		>
			{children}
		</StyledSection>
	);
};

export default Section;
